module.exports = __webpack_public_path__ + "img/wf.850539e1.svg";